// 非遗相关接口
import request from '@/utils/request'

// 非遗名录详情接口
export function getIchProjectInfoDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/ichProjectInfoApi/getIchProjectInfoDetails?id=${id}`,
    method: 'get',
  })
}

// 非遗传承人详情接口
export function getichPersonInfoDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/ichPersonInfoApi/getichPersonInfoDetails?id=${id}`,
    method: 'get',
  })
}

// 根据非遗项目id查询传承人
export function getIchPersonByProjectId(id) {
  return request({
    url: `/cultureCantonDemoApi/ichPersonInfoApi/getIchPersonByProjectId?projectId=${id}`,
    method: 'get',
  })
}

// 根据传承人id查询非遗项目
export function getIchProjectByPersonId(id) {
  return request({
    url: `/cultureCantonDemoApi/ichProjectInfoApi/getIchProjectByPersonId?personId=${id}`,
    method: 'get',
  })
}
